import { LinkOutFill18Icon } from "@vygruppen/spor-icon-react";
import {
  AdminLink,
  adminLinks,
} from "features/Header/Menu/externalLinks/links";
import { useTranslation } from "react-i18next";
import { Button, Heading } from "shared/components/Spor";
import { ObtrusiveScrollCss } from "shared/components/transitions/scroll";
import chainLink from "shared/icons/chain-link.svg?react";
import { useDropsRole } from "stores/useDropsRole";
import styled from "styled-components";

const ExternalLinkList = styled.ul`
  ${ObtrusiveScrollCss};
  background-color: ${({ theme }) => theme.colorBackgroundSecondary};
  list-style: none;
  padding-right: 12px;
  overflow: auto;
  margin: 0;
`;

const TitleContainer = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  margin-left: 0;
  margin-top: 18px;
  margin-bottom: 6px;
`;

const RowContainer = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  margin-left: 30px;
  transition: color 0.2s linear;

  &:hover {
    color: ${({ theme }) => theme.colorTextDisabled};

    & svg path {
      fill: ${({ theme }) => theme.colorTextMain};
    }
  }
`;

const ChainLinkStyled = styled(chainLink)`
  align-self: center;
  margin-left: 20px;
  margin-right: 10px;

  width: 20px;
  path {
    fill: ${({ theme }) => theme.colorTextMain};
  }
`;

const StyledLinkOutFill18Icon = styled(LinkOutFill18Icon)`
  path {
    fill: ${({ theme }) => theme.colorTextDisabled};
  }
`;

export const ExternalLinks = () => {
  const { t } = useTranslation();
  const { role: roleState } = useDropsRole();

  const linksForUserRole = adminLinks
    .filter((link: AdminLink) => link.roles.includes(roleState))
    .sort((a: AdminLink, b: AdminLink) => a.label.localeCompare(b.label));

  if (linksForUserRole.length > 0) {
    return (
      <ExternalLinkList>
        <TitleContainer as="div">
          <ChainLinkStyled />
          <Heading as="h1" variant="sm" fontWeight="600">
            {t("Lenker")}
          </Heading>
        </TitleContainer>
        {linksForUserRole.map((link) => (
          <RowContainer
            key={`link-${link.label}`}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              rightIcon={<StyledLinkOutFill18Icon />}
              variant="ghost"
              size="sm"
              width="100%"
            >
              {link.label}
            </Button>
          </RowContainer>
        ))}
      </ExternalLinkList>
    );
  }

  return null;
};
